import { render, staticRenderFns } from "./tabs-remarks.vue?vue&type=template&id=f121f76c&"
import script from "./tabs-remarks.vue?vue&type=script&lang=js&"
export * from "./tabs-remarks.vue?vue&type=script&lang=js&"
import style0 from "./tabs-remarks.vue?vue&type=style&index=0&id=f121f76c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports